<div
  class="table"
  [ngClass]="{
    'offline': !table.online,
    'editing': isEdited,
    'call': table.statusMain,
    'unlinked': !table.online && (table.deviceUuid === null && table.dwallDeviceId === null),
    'connectable': !table.online && (table.deviceUuid === null && table.dwallDeviceId !== null),
    'shake': isEdited,
    'cancel': !isEdited && (table.statusMain || table.statusSecondary || table.statusTertiary)
  }"
  (click)="cancelCalled(table);"
>
  <div class="table__info">
    <div class="table__settings-wrapper">
      <div class="checkbox-wrapper" *ngIf="isEdited">
        <input type="checkbox"
               [disabled]="!table.deviceUuid || !table.online"
               [ngModel]="selectedTables?.has(table.id)"
               (ngModelChange)="checkTables($event, table.id)"
               class="checkbox-select-tables"
        >
      </div>

      <button class="btn settings"
              *ngIf="!isWaiter && isEdited"
              (click)="openTableEditModal(table)"
      >
        <svg width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0l-30.1 30 97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2l-18.7-18.6zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.8 15.7-7.4 21.9-13.5l167.3-167.4-98-98-167.3 167.4zM96 64c-53 0-96 43-96 96v256c0 53 43 96 96 96h256c53 0 96-43 96-96v-96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"/>
        </svg>
      </button>
    </div>

    <app-table-statuses
      [table]="table"
      [callWaiter]="restaurant.features?.callWaiter ?? restaurant.features?.callWaiter
    ">
    </app-table-statuses>

    <div class="field name">
      <span class="name-content">
        <span class="name-row">
          <span *ngIf="table.online" class="indicator online" matTooltip="Online"></span>
          <span
            *ngIf="!table.online && (table.deviceUuid === null && table.dwallDeviceId !== null)"
            class="indicator connectable"
            matTooltip="Ready to connect when online"
          >
            <svg xmlns="http://www.w3.org/2000/svg"
                 width="24"
                 height="24"
                 viewBox="0 0 24 24"
                 fill="none"
                 stroke="currentColor"
                 stroke-linecap="round"
                 stroke-linejoin="round"
                 aria-hidden="true">
              <g stroke-width="2">
                <path d="M5 8a8 8 0 0 1 13-2"/>
                <path d="M18 3v4h-4"/>
                <path d="M19 16a8 8 0 0 1-13 2"/>
                <path d="M6 21v-4h4"/>
              </g>
              <g stroke-width="1.4">
                <rect x="7.5"
                      y="10"
                      width="6"
                      height="4"
                      rx="2"
                      transform="rotate(-45 10.5 12)"/>
                <rect x="10.5"
                      y="10"
                      width="6"
                      height="4"
                      rx="2"
                      transform="rotate(-45 13.5 12)"/>
              </g>
            </svg>
          </span>
          <span
            *ngIf="table.online === false && !(table.deviceUuid === null && table.dwallDeviceId !== null)"
            class="indicator offline"
            matTooltip="Offline"
          ></span>
          <span
            *ngIf="table.online !== false && table.online !== true"
            class="indicator undefined"
            matTooltip="Unknown"
          ></span>
          <span class="name">{{ table.name }}</span>
        </span>
        <span *ngIf="table.number !== null && table.number !== undefined" class="number">
          {{ 'pages.tables.content.tableNumber' | translate: { number: table.number } }}
        </span>
      </span>
    </div>

    <div class="field device-status">
      <div class="battery" #batteryStatus>
        <ng-container *ngIf="table.batteryLevel.level === null; else batteryLevelAvailable">
          <div class="battery__bar">N/A</div>
        </ng-container>
        <ng-template #batteryLevelAvailable>
          <div
            class="battery__bar"
            [class.battery__bar--green]="table.batteryLevel.level && table.batteryLevel.level > 0.3"
            [class.battery__bar--orange]="table.batteryLevel.level && table.batteryLevel.level > 0.1 && table.batteryLevel.level <= 0.3"
            [class.battery__bar--red]="table.batteryLevel.level && table.batteryLevel.level <= 0.1"
          >
            <span *ngIf="table.batteryLevel.charging" class="battery__bar__charging">⚡</span>
            {{ ((table.batteryLevel.level ? table.batteryLevel.level : 0) * 100).toFixed(0) }}%
          </div>
        </ng-template>
      </div>
      <div class="field device-status__updatedAt" *ngIf="table.batteryLevel.updatedAt">
            <span>
              {{
                ('pages.tables.content.lastUpdated' | translate) + ' '
                + (table.batteryLevel.updatedAt | date: 'short')
                + ' (' + (this.updatedAt$ | async | dateAgo) + ')'
              }}
            </span>
      </div>
    </div>

    <div *ngIf="table.description" class="field description">
      {{ table.description }}
    </div>

    <div class="field bill-qr" *ngIf="table.invoiceQRCodeUrl">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
        <path d="M220,0H20C8.954,0,0,8.954,0,20v200c0,11.046,8.954,20,20,20h200c11.046,0,20-8.954,20-20V20C240,8.954,231.046,0,220,0z     M200,200H40V40h160V200z"/>
        <path d="M164.445,55.556H75.556c-11.046,0-20,8.954-20,20v88.888c0,11.046,8.954,20,20,20h88.888c11.046,0,20-8.954,20.001-19.999    V75.556C184.445,64.51,175.491,55.556,164.445,55.556z M144.445,144.444H95.556V95.556h48.889V144.444z"/>
        <path d="M492,0H292c-11.046,0-20,8.954-20,20v200c0,11.046,8.954,20,20,20h200c11.046,0,20-8.954,20-20V20    C512,8.954,503.046,0,492,0z M472,200H312V40h160V200z"/>
        <path d="M436.444,55.556h-88.889c-11.046,0-20,8.954-20,20v88.888c0,11.046,8.954,20,20,20h88.889c11.046,0,20-8.954,20-19.999    V75.556C456.444,64.51,447.49,55.556,436.444,55.556z M416.445,144.444h-48.889V95.556h48.889V144.444z"/>
        <path d="M220,272H20c-11.046,0-20,8.954-20,20v200c0,11.046,8.954,20,20,20h200c11.046,0,20-8.954,20-20V292    C240,280.954,231.046,272,220,272z M200,472H40V312h160V472z"/>
        <path d="M164.445,327.555H75.556c-11.046,0-20,8.954-20,20v88.889c0,11.046,8.954,20,20,20h88.888c11.046,0,20-8.954,20.001-20    v-88.889C184.445,336.509,175.491,327.555,164.445,327.555z M144.445,416.444H95.556v-48.889h48.889V416.444z"/>
        <path d="M356.074,272H292c-11.046,0-20,8.954-20,20v64.074c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20V312h44.074    c11.046,0,20-8.954,20-20C376.074,280.954,367.12,272,356.074,272z"/>
        <path d="M492,272h-64.074c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20H472v44.074c0,11.046,8.954,20,20,20    c11.046,0,20-8.954,20-20V292C512,280.954,503.046,272,492,272z"/>
        <path d="M356.074,472H312v-44.074c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20V492c0,11.046,8.954,20,20,20h64.074    c11.046,0,20-8.954,20-20C376.074,480.954,367.12,472,356.074,472z"/>
        <path d="M492,407.926c-11.046,0-20,8.954-20,20V472h-44.074c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20H492    c11.046,0,20-8.954,20-20v-64.074C512,416.88,503.046,407.926,492,407.926z"/>
      </svg>
      <span>{{ 'pages.tables.content.qrPayment' | translate }}</span>
    </div>
  </div>
</div>
